export default __webpack_public_path__ + "static/media/1.8a19c867.JPG";